import React, { useState, useEffect, useRef } from "react";
import "primeicons/primeicons.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useNavigate } from "react-router-dom";
import {
  parsePhoneNumberFromString,
  getCountryCallingCode,
} from "libphonenumber-js";
import { Toast } from "primereact/toast";
import "react-phone-number-input/style.css";
import flags from "react-phone-number-input/flags";
import "./UserSettings.scss";
import { getUserDetails, saveUserDetails } from "./UserSettingsSevice";
const UserSettings = () => {
  const [formData, setFormData] = useState({
    email: "",
    countryCode: "NL",
    phone: "",
    id: "",
  });
  const toast = useRef(null);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getUserData();
  }, []);
  // Live validation helper
  const validatePhone = (value) => {
    if (!value) return "Phone number is required.";
    if (!isValidPhoneNumber(value)) return "Enter a valid phone number.";
    return ""; // no error
  };

  const handlePhoneChange = (value) => {
    console.log("Phone changed:", value);
    const phone = value || "";
    setFormData((prev) => ({ ...prev, phone }));
    // Live validation as user types
    const msg = validatePhone(phone);
    setErrors((prev) => ({ ...prev, phone: msg }));
  };

  function toE164FromIsoAndNational(iso, national) {
    if (!iso || !national) return "";
    const digits = String(national).replace(/\D+/g, "");
    const cc = getCountryCallingCode(iso); // e.g., "NL" -> "31"
    const candidate = `+${cc}${digits}`;
    const parsed = parsePhoneNumberFromString(candidate);
    return parsed?.isValid() ? parsed.number : candidate; // fall back to raw if unknown
  }

  const getUserData = async () => {
    // setChat([]);
    setLoading(true);
    try {
      console.log("try");
      const { data: result } = await getUserDetails();

      if (result) {
        const iso = result.PhoneCountryCode || "NL"; // "NL"
        const e164 = toE164FromIsoAndNational(iso, result.PhoneNumber);
        setFormData((prev) => ({
          ...prev,
          email: result.Email ?? prev.email,
          countryCode: iso ?? prev.countryCode,
          phone: e164 ?? prev.phone,
          id: result.contactId ?? prev.id,
        }));
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      // //toast.dismiss();
      //.error("Error getting messages!");
    } finally {
      setLoading(false);
    }
  };

  const buildContactPayload = () => {
    debugger;
    const iso = formData.countryCode; // e.g., "CA"
    const isd = `+${getCountryCallingCode(iso)}`; // e.g., "+1"

    // Extract national number from current E.164 value
    let phoneNumber = "";
    const parsed = formData.phone
      ? parsePhoneNumberFromString(formData.phone)
      : undefined;
    if (parsed?.nationalNumber) {
      phoneNumber = String(parsed.nationalNumber); // "5566363132"
    } else {
      // Fallback: strip ISD from beginning if present
      phoneNumber = (formData.phone || "").replace(/^\+\d+/, "");
    }

    return {
      contactId: Number(formData.id),
      email: formData.email,
      phoneCountryCode: iso,
      phoneNumber,
      isdCode: isd,
    };
  };

  const saveContactDetails = async () => {
    let data = buildContactPayload();
    setLoading(true);
    try {
      const result = await saveUserDetails(data);
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Contact details updated successfully",
        life: 6000,
      });
      const t = setTimeout(() => {
        navigate("/serviceRequestList");
      }, 1200);
      return () => clearTimeout(t);
    } catch (error) {
      toast.dismiss();
      toast.error("Error sending message! Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handlePhoneBlur = () => {
    const msg = validatePhone(formData.phone);
  };

  const handleSave = () => {
    const msg = validatePhone(formData.phone);
    setErrors((prev) => ({ ...prev, phone: msg }));
    if (msg) return;
    saveContactDetails();
  };

  const isPhoneValid = formData.phone && isValidPhoneNumber(formData.phone);

  return (
    <div className="user-settings-wrapper">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="user-settings-form">
        <button
          className="back-btn"
          type="button"
          onClick={() => navigate("/serviceRequestList")}
          style={{
            marginBottom: "12px",
            background: "none",
            border: "none",
            color: "#3498db",
            fontWeight: "bold",
            fontSize: "15px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <span
            className="pi pi-arrow-left"
            style={{ fontSize: "23px" }}
          ></span>{" "}
          Back
        </button>
        <div className="user-settings-header">USER CONTACT DETAILS</div>

        {/* Email (non-editable) */}
        <label className="form-label" htmlFor="email">
          Email
        </label>
        <input
          id="email"
          type="email"
          placeholder="Add your email"
          disabled
          className="form-input disabled-input"
          value={formData.email}
          readOnly
        />

        {/* Phone with country validation */}
        <label className="form-label" htmlFor="phone-input">
          Phone Number
        </label>
        <div id="phone-help" className="form-help">
          Please provide a contact number so the onboard crew can reach you
          directly if they have urgent questions about this request.
        </div>
        <Toast ref={toast} />

        <PhoneInput
          id="phone-input"
          name="phone"
          flags={flags}
          international
          defaultCountry={formData.countryCode}
          countryCallingCodeEditable={false}
          country={formData.countryCode}
          placeholder="Enter phone number"
          value={formData.phone}
          smartCaret={false}
          onChange={handlePhoneChange}
          onCountryChange={(country) =>
            setFormData((prev) => ({ ...prev, countryCode: country || "NL" }))
          } // or your handler
          onBlur={handlePhoneBlur}
          className={`phone-input ${errors.phone ? "error" : ""}`} // ✅ use "error" on the wrapper
          aria-invalid={!!errors.phone}
          aria-describedby={`phone-help ${errors.phone ? "phone-error" : ""}`}
        />

        {errors.phone && (
          <div id="phone-error" className="error-msg" role="alert">
            {errors.phone}
          </div>
        )}
      </div>

      {/* Bottom Save Button */}
      <div className="bottom-save-bar">
        <button
          className="save-btn"
          onClick={handleSave}
          disabled={!isPhoneValid}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default UserSettings;

// Add spinner and overlay styles
// Place this in UserSettings.scss for better maintainability
// .loading-overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   background: rgba(255,255,255,0.7);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 9999;
// }
// .spinner {
//   border: 6px solid #f3f3f3;
//   border-top: 6px solid #3498db;
//   border-radius: 50%;
//   width: 48px;
//   height: 48px;
//   animation: spin 1s linear infinite;
// }
// @keyframes spin {
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// }
